module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var u = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(u.exports, u, u.exports, n), u.l = !0, u.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var u in t) {
      n.d(r, u, function (e) {
        return t[e];
      }.bind(null, u));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 0);
}([function (t, e, n) {
  "use strict";

  var _r,
      u = this && this.__extends || (_r = function r(t, e) {
    return (_r = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    })(t, e);
  }, function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

    function n() {
      this.constructor = t;
    }

    _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
  }),
      o = this && this.__assign || function () {
    return (o = Object.assign || function (t) {
      for (var e, n = 1, r = arguments.length; n < r; n++) {
        for (var u in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, u) && (t[u] = e[u]);
        }
      }

      return t;
    }).apply(this, arguments);
  },
      i = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      f = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t.default = e;
  }),
      l = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.prototype.hasOwnProperty.call(t, n) && i(e, t, n);
    }
    return f(e, t), e;
  },
      c = this && this.__importDefault || function (t) {
    return t && t.__esModule ? t : {
      default: t
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.getGlobalRegistry = e.OutletNotFoundError = e.BaseOutletError = e.useOutletSetter = e.useOutlet = e.useNewOutlet = e.removeOutlet = e.hasOutlet = e.getOutlet = e.getNewOutlet = void 0;

  var a = c(n(1)),
      s = c(n(2)),
      p = l(n(3)),
      d = function (t) {
    function e() {
      return null !== t && t.apply(this, arguments) || this;
    }

    return u(e, t), e;
  }(Error);

  e.BaseOutletError = d;

  var O = function (t) {
    function e() {
      return null !== t && t.apply(this, arguments) || this;
    }

    return u(e, t), e;
  }(d);

  e.OutletNotFoundError = O;
  var v = new Map(),
      y = {
    autoDelete: !0
  };

  function _(t, e, n) {
    if (v.has(t)) return v.get(t);

    var r = function (t, e, n, r) {
      var u,
          i = "update",
          f = 0;
      return u = n instanceof Function ? n() : n, r = void 0 === r ? y : o(o({}, y), r), {
        register: function register(n) {
          function u(t) {
            n(t);
          }

          return f++, t.on(i, u), function () {
            f--, t.off(i, u), 0 === f && (null == r ? void 0 : r.autoDelete) && v.delete(e);
          };
        },
        update: function update(e) {
          if (e instanceof Function) {
            var n = e(u);
            p.isPromise(n) ? n.then(function (e) {
              u = e, t.emit(i, u);
            }) : (u = n, t.emit(i, u));
          } else u = e, t.emit(i, u);
        },
        getValue: function getValue() {
          return u;
        }
      };
    }(new s.default(), t, e, n);

    return v.set(t, r), r;
  }

  function h(t) {
    if (!v.has(t)) throw new O();
    return v.get(t);
  }

  function b(t) {
    return v.has(t);
  }

  function g(t) {
    v.delete(t);
  }

  e.getNewOutlet = _, e.getOutlet = h, e.hasOutlet = b, e.removeOutlet = g, e.useNewOutlet = function (t, e) {
    var n = a.default.useRef(!1);
    n.current || (_(t, e, {
      autoDelete: !1
    }), n.current = !0), a.default.useEffect(function () {
      return function () {
        g(t);
      };
    }, []);
  }, e.useOutlet = function (t, e, n) {
    var r = a.default.useRef(void 0 === e ? h(t) : _(t, e, n)).current,
        u = a.default.useState(r.getValue()),
        o = u[0],
        i = u[1];
    return a.default.useEffect(function () {
      return r.register(i);
    }, [r]), [o, r.update];
  }, e.useOutletSetter = function (t) {
    return a.default.useCallback(function (e) {
      if (!b(t)) throw new O();
      v.get(t).update(e);
    }, []);
  }, e.getGlobalRegistry = function () {
    return v;
  };
}, function (t, e) {
  t.exports = require("react");
}, function (t, e) {
  t.exports = require("eventemitter3");
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.isPromise = void 0, e.isPromise = function (t) {
    return "function" == typeof t.then;
  };
}]);